import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-final-report-menu',
  templateUrl: './final-report-menu.component.html',
  styleUrls: ['./final-report-menu.component.css']
})
export class FinalReportMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/final-reports/final-report-menu/final-report-menu/final-report-menu.component.ts